import React, { useMemo, useState } from "react";
import { Box, Button, FormControl, Heading, Input, Text, VStack, useToast } from "@chakra-ui/react";
import { Link as RouterLink, useNavigate, useSearchParams } from "react-router-dom";
import { VMS_COLORS } from "../constants/theme";
import { vmsApi } from "../services/vmsApi";

const VmsResetPassword = () => {
  const [params] = useSearchParams();
  const token = useMemo(() => params.get("token") || "", [params]);
  const navigate = useNavigate();
  const toast = useToast();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) {
      toast({ title: "Invalid link", description: "Reset token is missing.", status: "error" });
      return;
    }
    if (!newPassword || !confirmPassword) {
      toast({ title: "Missing fields", description: "Enter and confirm your new password.", status: "warning" });
      return;
    }
    setIsLoading(true);
    try {
      const res = await vmsApi.resetPassword({
        token,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });
      toast({
        title: "Password reset successful",
        description: res?.message || "You can now log in.",
        status: "success",
      });
      navigate("/vms/login", { replace: true });
    } catch (err) {
      toast({ title: "Reset failed", description: err?.message, status: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box minH="100vh" bg={VMS_COLORS.bg} display="grid" placeItems="center" p={4}>
      <Box bg="white" w="100%" maxW="460px" borderRadius="18px" border="1px solid" borderColor="gray.200" p={6}>
        <VStack as="form" align="stretch" spacing={4} onSubmit={submit}>
          <Heading size="md">Reset Password</Heading>
          <Text fontSize="sm" color="gray.600">
            Set a new password for your VMS account.
          </Text>
          <FormControl>
            <Input
              type="password"
              placeholder="New password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              bg="#F3F4F6"
              borderColor="transparent"
            />
          </FormControl>
          <FormControl>
            <Input
              type="password"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              bg="#F3F4F6"
              borderColor="transparent"
            />
          </FormControl>
          <Button type="submit" bg={VMS_COLORS.primary} color="white" isLoading={isLoading}>
            Reset password
          </Button>
          <Button as={RouterLink} to="/vms/login" variant="ghost" size="sm">
            Back to login
          </Button>
        </VStack>
      </Box>
    </Box>
  );
};

export default VmsResetPassword;
